import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent, toRefs, ref } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import { capitalize } from "@Shared/@Utils/helpers/text";
import { showToast } from "@Shared/@Utils/constants";
import { copyFrom, formatMoney, formatRate, formatTerm } from "./scenario-calcs";
import i18n from "@Shared/i18n";
import * as FinancialToolsActions from "../store/financial-tools-actions";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { showBModal } from "@Shared/components/bootstrap/BModal";
const {
  useActions: useFinancialToolsActions
} = createNamespacedHelpers("FinancialToolsStore");
export default defineComponent({
  name: "UserSbScenarioComparison",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    GenericModal,
    SimpleButton
  }),
  props: {
    bean: {
      type: Object,
      required: true
    },
    isEmbedded: {
      type: Boolean,
      default: false
    }
  },
  emits: ["set-scenario-as-mortgage"],
  setup(props, {
    emit
  }) {
    const {
      bean
    } = toRefs(props);
    const sbmort = bean.value.generatedMS[0];
    let showCompare = true;
    const selectedScenarioIndex = ref(null);
    const showModalShow = ref(false);
    function formatMoneySign(val) {
      let ret = formatMoneyValueLong(val);
      if (val > 0) ret = "+" + ret;
      return ret;
    }
    function getSelectedScenario() {
      const selectedIndex = selectedScenarioIndex.value;
      if (selectedIndex === null) return null;
      const scenario = bean.value.selectedMS[selectedIndex];
      if (!scenario || scenario.savedScenarioId <= 0) return null;
      return scenario;
    }
    function replaceScenarios() {
      const selectedScenario = getSelectedScenario();
      if (selectedScenario) {
        selectedScenario.amortizationTerm = 300;
        copyFrom(bean.value.editedMortgageScenario, selectedScenario);
        return;
      }
      showToast("error", i18n.t("financial-tools.sc_replaceNoScenario").toString());
    }
    function checkScenarioAsMortgage() {
      const selectedScenario = getSelectedScenario();
      if (!selectedScenario) {
        showToast("error", i18n.t("financial-tools.sc_replaceNoScenario").toString());
        return;
      }
      showBModal("confirm-set-modal", {}, this);
    }
    function setScenarioAsMortgage() {
      const selectedScenario = getSelectedScenario();
      emit("set-scenario-as-mortgage", selectedScenario);
    }
    const {
      PRINT_SCENARIO_BUILDER_FORM
    } = useFinancialToolsActions([FinancialToolsActions.PRINT_SCENARIO_BUILDER_FORM]);
    const isLoading = ref(false);
    const loadingSucceeded = ref(true);
    const printallScenarios = async () => {
      isLoading.value = true;
      loadingSucceeded.value = true;
      const selectedScenarios = bean.value.selectedMS;
      const values = _filterInstanceProperty(selectedScenarios).call(selectedScenarios, ms => ms.pAndIPaymentAmount > 0);
      values.unshift(sbmort);
      const data = {
        preparedFor: "",
        values
      };
      try {
        await PRINT_SCENARIO_BUILDER_FORM({
          data
        });
      } catch (e) {
        loadingSucceeded.value = false;
        console.error(e);
      }
      isLoading.value = false;
    };
    return {
      sbmort,
      showCompare,
      formatMoney,
      formatMoneySign,
      formatRate,
      formatTerm,
      capitalize,
      selectedScenarioIndex,
      replaceScenarios,
      showModalShow,
      checkScenarioAsMortgage,
      setScenarioAsMortgage,
      printallScenarios,
      isLoading,
      loadingSucceeded
    };
  }
});